import { useEnableCloud } from '@affine/core/components/hooks/affine/use-enable-cloud';
import type { Workspace } from '@affine/core/modules/workspace';
import { track } from '@affine/track';
import type { Store } from '@blocksuite/affine/store';
import { useCallback, useState } from 'react';

import { DocConfigurationDialog } from './doc-configuration-dialog';
import { DefaultShareButton } from './share-menu/share-menu';
export { CloudSvg } from './cloud-svg';
export { DocConfigurationDialog } from './doc-configuration-dialog';
export { ShareMenuContent } from './share-menu';

type SharePageModalProps = {
  workspace: Workspace;
  page: Store;
};

export const SharePageButton = ({ workspace, page }: SharePageModalProps) => {
  const confirmEnableCloud = useEnableCloud();
  const [open, setOpen] = useState(false);
  const handleOpenShareModal = useCallback((open: boolean) => {
    if (open) {
      track.$.sharePanel.$.open();
    }
  }, []);

  return (
    <>
      <DefaultShareButton onClick={() => setOpen(true)} />
      <DocConfigurationDialog
        open={open}
        onOpenChange={nextOpen => {
          setOpen(nextOpen);
          handleOpenShareModal(nextOpen);
        }}
        workspaceMetadata={workspace.meta}
        currentPage={page}
        onEnableAffineCloud={() =>
          confirmEnableCloud(workspace, {
            openPageId: page.id,
          })
        }
      />
    </>
  );
};
